import { Text } from '$tablet-app/src/app/components/Text/Text';
import { format, isSameDay } from 'date-fns';
import React, { FC } from 'react';

interface DateTimeFieldDisplayProps {
  value: Date;
}

const DateTimeFieldDisplay: FC<DateTimeFieldDisplayProps> = (props) => {
  const { value } = props;

  const isToday = isSameDay(value, new Date());
  const dayText = isToday ? 'Today' : format(value, 'eeee');

  return (
    <>
      <Text>{dayText + ', ' + format(value, 'd MMM')}</Text>
      <Text preset="bold">{format(value, 'h:mm a')}</Text>
    </>
  );
};

export default DateTimeFieldDisplay;
